// extracted by mini-css-extract-plugin
export default {"inputLookupOption":"tccoA0VCyCT3aU9qGKdC"};